import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';

import { Base } from './Base';

const classes = {
  active: 'active',
  disabled: 'disabled',
  hidden: 'hidden',
  hidePrice: 'hide-price',
  showStatus: 'show-status',
  waiting: 'waiting'
};

const selectors = {
  optionLink: '.option-link',
  radioContainer: '.radio-container',
  radioLabel: '.radio-label',
};

export class BuyBar extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.productAvailable = false;
    this.radioLabels = [];
    this.init();
  }

  init() {
    this.getRadioLabels();
    this.getInitialStatus();
    this.bindVariantChangedListener();
    this.bindSubmitListeners();
    this.bindRadioLabelListeners();
    this.bindFormSubmitListener();
    this.updateSubmit();
  }

  getRadioLabels() {
    const { selectSize } = this.refs;

    if (selectSize) {
      this.radioLabels = selectSize.querySelectorAll(selectors.radioLabel);
    }
  }

  getInitialStatus() {
    if (this.element.dataset.productAvailable === 'true') {
      this.productAvailable = true;
    }
  }

  bindVariantChangedListener() {
    this.variantChangedHandler = this.handleVariantChanged.bind(this);
    window.addEventListener(events.VARIANT_CHANGED, this.variantChangedHandler);
  }

  handleVariantChanged(e) {
    const { variant, size_selectors } = e.detail;

    this.currentVariant = variant;

    this.updateColor();
    this.updatePrice();
    this.updateLength();
    this.updateHiddenInput();
    this.updateSizeSelectors(size_selectors);
    this.updateSubmit();
  }

  updateColor() {
    const { swatch, swatchText } = this.refs;

    if (swatch && swatchText && this.currentVariant && this.currentVariant.color) {
      swatch.dataset.swatchName = this.currentVariant.color;
      swatch.title = this.currentVariant.color;
      swatchText.innerHTML = this.currentVariant.color;
    }
  }

  updatePrice() {
    const { price, submitPrice } = this.refs;

    if (price && this.hoveredRadioLabel && this.hoveredRadioLabel.dataset.price) {
      price.innerHTML = this.hoveredRadioLabel.dataset.price;
    } else if (price && this.selectedRadioLabel && this.selectedRadioLabel.dataset.price) {
      price.innerHTML = this.selectedRadioLabel.dataset.price;
    } else if (price && this.currentVariant && this.currentVariant.price) {
      price.innerHTML = this.currentVariant.price;
    }

    if (price && this.hoveredRadioLabel && this.hoveredRadioLabel.dataset.price) {
      submitPrice.innerHTML = this.hoveredRadioLabel.dataset.price;
    } else if (submitPrice && this.selectedRadioLabel && this.selectedRadioLabel.dataset.price) {
      submitPrice.innerHTML = this.selectedRadioLabel.dataset.price;
    } else if (submitPrice && this.currentVariant && this.currentVariant.price) {
      submitPrice.innerHTML = this.currentVariant.price;
    }
  }

  updateLength() {
    const { lengthText } = this.refs;

    if (lengthText && this.currentVariant && this.currentVariant.length) {
      lengthText.innerHTML = this.currentVariant.length;
    }
  }

  updateHiddenInput() {
    const { hiddenInput } = this.refs;

    if (hiddenInput) {
      hiddenInput.value = this.currentVariant.id
    }
  }

  updateSizeSelectors(sizeSelectorsData) {
    const { selectSize } = this.refs;

    let html = '';

    this.selectedRadioLabel = undefined;

    if (selectSize && sizeSelectorsData) {
      for (let i = 0; i < sizeSelectorsData.length; i++) {
        html += `<input type="radio" name="id" id="buy-bar-${sizeSelectorsData[i].id}" value="${sizeSelectorsData[i].id}" ${sizeSelectorsData[i].disabled ? 'disabled="disabled"' : ''} class="radio-input">`;
        html += `<label for="buy-bar-${sizeSelectorsData[i].id}" class="radio-label select-size__option ${sizeSelectorsData[i].disabled ? 'disabled' : ''} margin-bottom-0" data-price="${sizeSelectorsData[i].price}">${sizeSelectorsData[i].text}</label>`;
      }

      selectSize.innerHTML = html;

      this.getRadioLabels();
      this.bindRadioLabelListeners();
    }
  }

  bindSubmitListeners() {
    const { submitContainer } = this.refs;

    if (submitContainer) {
      submitContainer.addEventListener('mouseenter', () => {
        this.handleSubmitMouseOver();
      });

      submitContainer.addEventListener('mouseleave', () => {
        this.handleSubmitMouseOut();
      });
    }
  }

  handleSubmitMouseOver() {
    const { submit, submitText } = this.refs;

    if (!this.productAvailable) {
      submit.classList.add(classes.hidePrice);
      submitText.innerHTML = submit.dataset.textSoldOut;
    } else if (this.radioLabels.length > 0 && !this.selectedRadioLabel) {
      submit.classList.add(classes.hidePrice);
      submitText.innerHTML = submit.dataset.textMakeSelection;
    }
  }

  handleSubmitMouseOut() {
    const { submit, submitText } = this.refs;

    if (!this.productAvailable) {
      submit.classList.add(classes.hidePrice);
      submitText.innerHTML = submit.dataset.textSoldOut;
    } else if (this.radioLabels.length > 0 && !this.selectedRadioLabel) {
      submit.classList.remove(classes.hidePrice);
      submitText.innerHTML = submit.dataset.textAddToCart;
    }
  }

  updateSubmit() {
    const { submit, submitText } = this.refs;

    if (submit && submitText) {
      if (!this.productAvailable) {
        submit.classList.add(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textSoldOut;
        submit.setAttribute('disabled', 'disabled');
      } else if (this.hoveredRadioLabel && this.hoveredRadioLabel.classList.contains(classes.disabled)) {
        submit.classList.add(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textSelectionSoldOut;
        submit.setAttribute('disabled', 'disabled');
      } else if (this.hoveredRadioLabel && !this.hoveredRadioLabel.classList.contains(classes.disabled)) {
        submit.classList.remove(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textAddToCart;
        submit.removeAttribute('disabled');
      } else if (this.selectedRadioLabel && this.selectedRadioLabel.classList.contains(classes.disabled)) {
        submit.classList.add(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textSelectionSoldOut;
        submit.setAttribute('disabled', 'disabled');
      } else if (this.selectedRadioLabel && !this.selectedRadioLabel.classList.contains(classes.disabled)) {
        submit.classList.remove(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textAddToCart;
        submit.removeAttribute('disabled');
      } else if (this.radioLabels.length === 0 && this.currentVariant && !this.currentVariant.available) {
        submit.classList.add(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textSelectionSoldOut;
        submit.setAttribute('disabled', 'disabled');
      } else if (this.radioLabels.length === 0 && this.currentVariant && this.currentVariant.available) {
        submit.classList.remove(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textAddToCart;
        submit.removeAttribute('disabled', 'disabled');
      } else if (this.radioLabels.length > 0) {
        submit.classList.remove(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textAddToCart;
        submit.setAttribute('disabled', 'disabled');
      } else {
        submit.classList.remove(classes.hidePrice);
        submitText.innerHTML = submit.dataset.textAddToCart;
      }
    }
  }

  bindRadioLabelListeners() {
    this.radioLabels.forEach((radioLabel) => {
      radioLabel.addEventListener('click', (e) => {
        this.handleRadioLabelClick(e, radioLabel);
      });

      radioLabel.addEventListener('mouseenter', (e) => {
        this.hoveredRadioLabel = radioLabel;
        this.updatePrice();
        this.updateSubmit();
      });

      radioLabel.addEventListener('mouseleave', (e) => {
        this.hoveredRadioLabel = false;
        this.updatePrice();
        this.updateSubmit();
      });
    });
  }

  handleRadioLabelClick(e, clickedRadioLabel) {
    e.preventDefault();

    this.radioLabels.forEach((radioLabel) => {
      if (radioLabel === clickedRadioLabel) {
        if (!radioLabel.classList.contains(classes.active)) {
          document.getElementById(radioLabel.getAttribute('for')).checked = true;
          radioLabel.classList.add(classes.active);
          this.selectedRadioLabel = radioLabel;
        } else {
          document.getElementById(radioLabel.getAttribute('for')).checked = false;
          radioLabel.classList.remove(classes.active);
          this.selectedRadioLabel = undefined;
        }
      } else {
        document.getElementById(radioLabel.getAttribute('for')).checked = false;
        radioLabel.classList.remove(classes.active);
      }
    });

    this.updatePrice();
  }

  bindFormSubmitListener() {
    this.element.addEventListener('submit', (e) => {
      e.preventDefault();
      this.addToCart();
    });
  }

  addToCart() {
    const { hiddenInput, quantity } = this.refs;

    if (!this.element.classList.contains(classes.waiting) && !this.element.classList.contains(classes.showStatus)) {
      this.element.classList.add(classes.waiting);

      this.addSubmitLoadingIndicator();

      const quantityValue = quantity.value;

      let id = 0;

      if (hiddenInput) {
        id = hiddenInput.value;
      } else if (this.selectedRadioLabel) {
        id = document.getElementById(this.selectedRadioLabel.getAttribute('for')).value;
      }

      if (id != 0) {
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({
            quantity: quantityValue,
            id: id
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
        })
        .then((response) => {
          this.displaySubmitStatus(response.status >= 400);

          if (response.status >= 200 && response.status < 300) {
            dispatchEvent(window, events.CART_UPDATED, {
              numberOfItemsAdded: quantityValue
            });
          }

          setTimeout(() => {
            this.hideStatus();
          }, 3000)

          this.element.classList.remove(classes.waiting);
        });
      }
    }
  }

  addSubmitLoadingIndicator() {
    const { submitText, loadingIndicator } = this.refs;

    if (submitText && loadingIndicator) {
      submitText.innerHTML = loadingIndicator.innerHTML;
    }
  }

  displaySubmitStatus(error = false) {
    const { submit, submitText } = this.refs;

    this.element.classList.add(classes.showStatus);

    if (submit && submitText) {
      if (error) {
        submitText.innerHTML = submit.dataset.textNotAddedToCart;
      } else {
        submitText.innerHTML = submit.dataset.textAddedToCart;
      }
    }

    setTimeout(() => {
      this.updateSubmit();
    }, 3000)
  }

  hideStatus() {
    this.element.classList.remove(classes.showStatus);
  }

  cleanup() {
    window.removeEventListener(events.VARIANT_CHANGED, this.variantChangedHandler);
  }
}